function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Big - Alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.838-18.375h-15.75a2.623 2.623 0 0 0-2.625 2.588v11.776a2.6 2.6 0 0 0 2.625 2.588h3.937v3.408a.492.492 0 0 0 .784.4L1.933-1.46h5.906a2.623 2.623 0 0 0 2.625-2.588v-11.739a2.6 2.6 0 0 0-2.626-2.588zm1.35 14.438a1.316 1.316 0 0 1-1.313 1.312h-5.91a1.313 1.313 0 0 0-.788.263L-2.625.492v-2.461a.656.656 0 0 0-.656-.656h-4.594a1.316 1.316 0 0 1-1.313-1.312V-15.75a1.316 1.316 0 0 1 1.313-1.312h15.75a1.316 1.316 0 0 1 1.313 1.312zM-.037-7.912a.639.639 0 0 0 .693-.619v-5.906A.656.656 0 0 0 0-15.094a.656.656 0 0 0-.656.656v5.906a.616.616 0 0 0 .619.62zM0-6.891a.984.984 0 0 0-.984.984.985.985 0 0 0 .984.985.985.985 0 0 0 .984-.984A.982.982 0 0 0 0-6.891z",
    transform: "translate(20 27.6)",
    style: {
      fill: "#3a4043"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/IconAlert.2f36ffca77265e3c1606985f2c5e0d3e.svg";
export { ForwardRef as ReactComponent };